export const KASSA = 'KASSA'
export const ONLINE_SHOP = 'ONLINE_SHOP'

